import React, { useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./personalInfo.css";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DoneIcon from "@mui/icons-material/Done";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";

// Presentational field row: icon tile + label/value, with an optional edit pencil
// that flips to a "done" check while editing. All edit logic stays in the parent.
const FieldRow = ({ icon, label, display, canEdit, editing, onEdit, onDone, children }) => (
  <div className="pfRow">
    <span className="pfRowIcon">{icon}</span>
    <div className="pfRowMain">
      <div className="pfRowLabel">{label}</div>
      <div className="pfRowValue">{editing ? children : display || "-"}</div>
    </div>
    {canEdit && (
      <button
        type="button"
        className="pfPencil"
        onClick={editing ? onDone : onEdit}
        aria-label={editing ? "Save" : "Edit"}
      >
        {editing ? <DoneIcon sx={{ fontSize: 16 }} /> : <EditOutlinedIcon sx={{ fontSize: 15 }} />}
      </button>
    )}
  </div>
);

const PersonalInfo = (props) => {
  const [toggleEditName, settoggleEditName] = useState(false);
  const [toggleEditPhone, settoggleEditPhone] = useState(false);
  const [toggleEditEmergencyPhone, settoggleEditEmergencyPhone] =
    useState(false);
  const [toggleEditPresentAddress, settoggleEditPresentAddress] =
    useState(false);
  const [toggleEditAddress, settoggleEditAddress] = useState(false);
  const [toggleEditPosition, settoggleEditPosition] = useState(false);
  const [toggleEditJoining, settoggleEditJoining] = useState(false);
  const [toggleEditBirthday, settoggleEditBirthday] = useState(false);
  const [toggleEditEmail, settoggleEditEmail] = useState(false);
  const [toggleEditPassword, settoggleEditPassword] = useState(false);
  // HR/Executive only: click-to-reveal the employee's password (hidden by default).
  const [toggleEditCNIC, settoggleEditCNIC] = useState(false);
  const [toggleEditCardId, settoggleEditCardId] = useState(false);
  const [toggleEditBank, settoggleEditBank] = useState(false);
  const [toggleEditDepartment, settoggleEditDepartment] = useState(false);
  const [toggleEditLeadManager, settoggleEditLeadManager] = useState(false);
  const [managerNames, setManagerNames] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);

  const Employee = props.Employee;
  const user = props.user;

  const [name, setName] = useState(Employee ? Employee.name : "");
  const [email, setEmail] = useState(Employee ? Employee.email : "");
  const [phone, setPhone] = useState(Employee ? Employee.phone : "");
  const [emergencyPhone, setEmergencyPhone] = useState(
    Employee ? Employee.emergencyPhone : ""
  );
  const [address, setAddress] = useState(Employee ? Employee.address : "");
  const [presentAddress, setPresentAddress] = useState(
    Employee ? Employee.presentAddress : ""
  );
  const [bankD, setBankD] = useState(Employee ? Employee.bankD : "");
  const [joining, setJoining] = useState(
    Employee ? Employee.joining.slice(0, 10) : ""
  );
  const [position, setPosition] = useState(Employee ? Employee.pos : "");
  const [cnic, setCNIC] = useState(Employee ? Employee.cnic : "");
  const [cardId, setCardId] = useState(Employee ? Employee.cardId || "" : "");
  const [birthday, setBirthday] = useState(
    Employee ? Employee.birthday.slice(0, 10) : ""
  );
  const [department, setDepartment] = useState(
    Employee ? Employee.department : ""
  );

  const [leadManager, setleadManager] = useState(
    Employee ? Employee.leadManager : ""
  );

  const allDepartments = [
    "Marketing Team",
    "Sales Team",
    "Content Team",
    "Dev Team",
    "Media Buying",
    "Finance",
    "HR",
  ];

  const inputEditHandler = (name, email, field, value, toggleEditField) => {
    trackEmployeeUpdateRequest(name, email, field, value);
    toggleEditField(false);
  };

  const trackEmployeeUpdateRequest = async (name, email, field, value) => {
    try {
      const response = await fetch(
        "https://hr-backend-72v1.onrender.com/requestEmployeeUpdate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            email,
            field,
            value,
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        setShowAlert(true);
        setAlertMessage(
          "Update request submitted successfully\nWait for the Approval from HR"
        );
      } else {
        // Say WHY (e.g. "This field can't be changed through a profile request.")
        // instead of a generic failure.
        alert(data.message || "Error submitting update request");
      }
    } catch (error) {
      alert("Error submitting update request");
    }
  };

  // The card number is assigned by HR, not requested by the employee, so it writes
  // straight through the HR-only /updateEmployee endpoint instead of the
  // request-and-approve flow the other fields use.
  const saveCardId = async () => {
    settoggleEditCardId(false);
    try {
      const response = await fetch(
        "https://hr-backend-72v1.onrender.com/updateEmployee",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: Employee.email,
            field: "cardId",
            value: cardId,
          }),
        }
      );
      const data = await response.json();
      setShowAlert(true);
      setAlertMessage(
        data.success
          ? "Insurance Card Number updated"
          : data.message || "Error updating Insurance Card Number"
      );
    } catch (error) {
      setShowAlert(true);
      setAlertMessage("Error updating Insurance Card Number");
    }
  };

  useEffect(() => {
    fetch("https://hr-backend-72v1.onrender.com/getallManagerNames")
      .then((response) => response.json())
      .then((data) => setManagerNames(data))
      .catch((error) => console.error("Error fetching manager names:", error));
  }, []);

  // This component isn't remounted when HR switches profiles, so re-seed the card
  // number from the newly-selected employee. Without this, saving would write the
  // previously-viewed person's card ID onto this one.
  useEffect(() => {
    setCardId(Employee?.cardId || "");
    settoggleEditCardId(false);
  }, [Employee?.email, Employee?.cardId]);

  // Role gates preserved from the original implementation.
  const canEditStd =
    user.role === "Employee" || user.role === "HR" || user.role === "Executive";
  const canEditHr = user.role === "HR" || user.role === "Executive";

  // Password reveal: HR/Executive may reveal ANY employee's password; a regular
  // employee may reveal only their OWN. The explicit self-check means we can never
  // surface someone else's password to a non-admin, even if a future screen were to
  // render another person's profile (the backend already restricts the record itself
  // to self-or-admin, so this is defence in depth).
  return (
    <div className="pfWrap">
      <header className="pfHeader">
        <h1 className="pfTitle">Personal</h1>
        <p className="pfSubtitle">
          Your identity, contact and employment details at a glance
        </p>
      </header>

      <div className="pfGrid">
        {/* Identity */}
        <section className="pfCard">
          <header className="pfCardHead">
            <span className="pfCardIcon">
              <BadgeOutlinedIcon sx={{ fontSize: 17 }} />
            </span>
            <h3 className="pfCardTitle">Identity</h3>
          </header>
          <div className="pfCardBody">
            <FieldRow
              icon={<PersonOutlineIcon sx={{ fontSize: 16 }} />}
              label="Full Name"
              display={name}
              canEdit={canEditStd}
              editing={toggleEditName}
              onEdit={() => settoggleEditName(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "name", name, settoggleEditName)
              }
            >
              <input
                className="pfInput"
                type="text"
                placeholder="Enter Name here"
                maxLength="50"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FieldRow>

            <FieldRow
              icon={<BadgeOutlinedIcon sx={{ fontSize: 16 }} />}
              label="CNIC"
              display={cnic}
              canEdit={canEditStd}
              editing={toggleEditCNIC}
              onEdit={() => settoggleEditCNIC(true)}
              onDone={() =>
                inputEditHandler(Employee.name, email, "cnic", cnic, settoggleEditCNIC)
              }
            >
              <input
                className="pfInput"
                type="text"
                placeholder="Enter CNIC here"
                maxLength="50"
                value={cnic}
                onChange={(e) => setCNIC(e.target.value)}
              />
            </FieldRow>

            <FieldRow
              icon={<CreditCardOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Insurance Card Number"
              display={cardId}
              canEdit={canEditHr}
              editing={toggleEditCardId}
              onEdit={() => settoggleEditCardId(true)}
              onDone={saveCardId}
            >
              <input
                className="pfInput"
                type="text"
                placeholder="e.g. 01-000000000114081-00001"
                maxLength="50"
                value={cardId}
                onChange={(e) => setCardId(e.target.value)}
              />
            </FieldRow>

            <FieldRow
              icon={<CalendarMonthOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Date of Birth"
              display={birthday}
              canEdit={canEditStd}
              editing={toggleEditBirthday}
              onEdit={() => settoggleEditBirthday(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "birthday", birthday, settoggleEditBirthday)
              }
            >
              <DatePicker
                className="pfInput"
                selected={new Date(birthday)}
                onChange={(date) => setBirthday(date.toISOString().slice(0, 10))}
                dateFormat="yyyy-MM-dd"
              />
            </FieldRow>
          </div>
        </section>

        {/* Contact */}
        <section className="pfCard">
          <header className="pfCardHead">
            <span className="pfCardIcon">
              <PhoneOutlinedIcon sx={{ fontSize: 17 }} />
            </span>
            <h3 className="pfCardTitle">Contact</h3>
          </header>
          <div className="pfCardBody">
            <FieldRow
              icon={<PhoneOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Phone"
              display={phone}
              canEdit={canEditStd}
              editing={toggleEditPhone}
              onEdit={() => settoggleEditPhone(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "phone", phone, settoggleEditPhone)
              }
            >
              <input
                className="pfInput"
                type="text"
                placeholder="Enter Phone here"
                maxLength="50"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </FieldRow>

            <FieldRow
              icon={<ShieldOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Emergency Phone"
              display={emergencyPhone}
              canEdit={canEditStd}
              editing={toggleEditEmergencyPhone}
              onEdit={() => settoggleEditEmergencyPhone(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "emergencyPhone", emergencyPhone, settoggleEditEmergencyPhone)
              }
            >
              <input
                className="pfInput"
                type="text"
                placeholder="Enter Emergency Phone here"
                maxLength="50"
                value={emergencyPhone}
                onChange={(e) => setEmergencyPhone(e.target.value)}
              />
            </FieldRow>

            <FieldRow
              icon={<MailOutlineIcon sx={{ fontSize: 16 }} />}
              label="Email"
              display={email}
              canEdit={false}
              editing={toggleEditEmail}
            />
          </div>
        </section>

        {/* Employment */}
        <section className="pfCard">
          <header className="pfCardHead">
            <span className="pfCardIcon">
              <WorkOutlineIcon sx={{ fontSize: 17 }} />
            </span>
            <h3 className="pfCardTitle">Employment</h3>
          </header>
          <div className="pfCardBody">
            <FieldRow
              icon={<ApartmentOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Department"
              display={department}
              canEdit={canEditStd}
              editing={toggleEditDepartment}
              onEdit={() => settoggleEditDepartment(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "department", department, settoggleEditDepartment)
              }
            >
              <select
                className="pfInput"
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
              >
                <option value="" disabled>
                  Select Department
                </option>
                {allDepartments.map((dept) => (
                  <option key={dept} value={dept}>
                    {dept}
                  </option>
                ))}
              </select>
            </FieldRow>

            <FieldRow
              icon={<WorkOutlineIcon sx={{ fontSize: 16 }} />}
              label="Position"
              display={position}
              canEdit={canEditStd}
              editing={toggleEditPosition}
              onEdit={() => settoggleEditPosition(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "pos", position, settoggleEditPosition)
              }
            >
              <input
                className="pfInput"
                type="text"
                placeholder="Enter Position here"
                maxLength="50"
                value={position}
                onChange={(e) => setPosition(e.target.value)}
              />
            </FieldRow>

            <FieldRow
              icon={<HowToRegOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Team Lead"
              display={leadManager}
              canEdit={canEditStd}
              editing={toggleEditLeadManager}
              onEdit={() => settoggleEditLeadManager(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "leadManager", leadManager, settoggleEditLeadManager)
              }
            >
              <select
                className="pfInput"
                value={leadManager}
                onChange={(e) => setleadManager(e.target.value)}
              >
                <option value="" disabled>
                  Select a Team Lead
                </option>
                {managerNames.map((nm, index) => (
                  <option key={index} value={nm}>
                    {nm}
                  </option>
                ))}
              </select>
            </FieldRow>

            <FieldRow
              icon={<CalendarMonthOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Joining Date"
              display={joining}
              canEdit={canEditStd}
              editing={toggleEditJoining}
              onEdit={() => settoggleEditJoining(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "joining", joining, settoggleEditJoining)
              }
            >
              <DatePicker
                className="pfInput"
                selected={joining ? new Date(joining) : new Date()}
                onChange={(date) => setJoining(date.toISOString().slice(0, 10))}
                dateFormat="yyyy-MM-dd"
              />
            </FieldRow>
          </div>
        </section>

        {/* Residential Address */}
        <section className="pfCard">
          <header className="pfCardHead">
            <span className="pfCardIcon">
              <LocationOnOutlinedIcon sx={{ fontSize: 17 }} />
            </span>
            <h3 className="pfCardTitle">Residential Address</h3>
          </header>
          <div className="pfCardBody">
            <FieldRow
              icon={<HomeOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Permanent Address"
              display={address}
              canEdit={canEditStd}
              editing={toggleEditAddress}
              onEdit={() => settoggleEditAddress(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "address", address, settoggleEditAddress)
              }
            >
              <input
                className="pfInput"
                type="text"
                placeholder="Enter Permanent Address here"
                maxLength="50"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </FieldRow>

            <FieldRow
              icon={<LocationOnOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Present Address"
              display={presentAddress}
              canEdit={canEditStd}
              editing={toggleEditPresentAddress}
              onEdit={() => settoggleEditPresentAddress(true)}
              onDone={() =>
                inputEditHandler(Employee.name, Employee.email, "presentAddress", presentAddress, settoggleEditPresentAddress)
              }
            >
              <input
                className="pfInput"
                type="text"
                placeholder="Enter Present Address here"
                maxLength="100"
                value={presentAddress}
                onChange={(e) => setPresentAddress(e.target.value)}
              />
            </FieldRow>
          </div>
        </section>

        {/* Account & Banking (full width) */}
        <section className="pfCard pfCard--full">
          <header className="pfCardHead">
            <span className="pfCardIcon">
              <LockOutlinedIcon sx={{ fontSize: 17 }} />
            </span>
            <h3 className="pfCardTitle">Account &amp; Banking</h3>
          </header>
          <div className="pfCardBody pfBankGrid">
            {/* Permanently masked. There used to be an eye here that revealed the stored
                password to HR, Executives and the person themselves — which only worked
                because the column was plaintext, and made every one of those accounts a
                silent way to read someone's credentials. Passwords are bcrypt hashes now:
                there is nothing to reveal, the API no longer sends the field at all, and
                the way back in is "Forgot your password?" on the sign-in screen or an HR
                reset, both of which ISSUE a password rather than disclose one. */}
            <FieldRow
              icon={<LockOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Password"
              display="••••••••"
              canEdit={false}
              editing={toggleEditPassword}
            />
            <FieldRow
              icon={<AccountBalanceOutlinedIcon sx={{ fontSize: 16 }} />}
              label="Bank Details"
              display={bankD}
              canEdit={canEditHr}
              editing={toggleEditBank}
              onEdit={() => settoggleEditBank(true)}
              onDone={() =>
                inputEditHandler(Employee.name, email, "bankD", bankD, settoggleEditBank)
              }
            >
              <input
                className="pfInput"
                type="text"
                placeholder="Enter Bank details here"
                maxLength="100"
                value={bankD}
                onChange={(e) => setBankD(e.target.value)}
              />
            </FieldRow>
          </div>
        </section>
      </div>

      <Snackbar
        open={showAlert}
        autoHideDuration={15000}
        onClose={() => setShowAlert(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setShowAlert(false)} severity="info">
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default PersonalInfo;
